import React, { Component } from 'react';
import { Form, Icon, Input, Button, Checkbox, Spin, message} from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import equal from 'fast-deep-equal';
import { Link } from 'react-router-dom';
import ConfigSite from '../../configSite';
import esEs from './../../assets/i18n/es_ES.json';

class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      username: '',
      password: '',
      isRememberChecked: false,
      displaySpinner: false
     }
  }

  componentDidMount() {
    if (localStorage.getItem('isRemember') !== 'false' && localStorage.getItem('username') !== '') {
      this.setState({
        isRememberChecked: true,
        username: localStorage.getItem('username'),
        password: localStorage.getItem('password')
      });
    }
  }

  handleReset = () => {
    this.setState({ username: '', password: '' });
    this.props.form.resetFields();
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields( (err, values) => {
      if (!err) {
        const { username, password, isRememberChecked } = this.state;
        localStorage.setItem('username', username);
        localStorage.setItem('password', password);
        localStorage.setItem('isRemember', isRememberChecked);

        this.props.onSignin(this.state);
      }
    })
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  onChangeRememberMe = event => {
    this.setState({ isRememberChecked: event.target.checked });
  }

  componentDidUpdate(prevProps) {
    if(!equal(this.props.response, prevProps.response)) {
      this.handleServiceResponse(this.props.response);
    }
  }

  redirectMainSiteDev(response) {
    const data = response.message;
    window.location.href = ConfigSite.APP_URL + '/?user=' + JSON.stringify(data.user) + '&accessToken=' + data.accessToken;
  }

  handleServiceResponse(response) {
    switch(response.status) {
      case 200:
        this.setState({ displaySpinner: true });
        const data = response.message;
        if (typeof(Storage) !== undefined) {
          localStorage.setItem('user', JSON.stringify(data.user));
          localStorage.setItem('accessToken', data.accessToken);
        }

        message.success(`${ esEs.SIGNIN.MESSAGES.SUCCESS }`);

        if (process.env.NODE_ENV !== 'production') {
          this.redirectMainSiteDev(response);
        } else {
          window.location.href = ConfigSite.APP_URL;
        }
      break;
      case 401:
        message.error(`${ esEs.SIGNIN.MESSAGES.INVALID }`, ConfigSite.TIME_DISPLAY_MESSAGES);
        this.handleReset();
      break;
      default:
        message.error(`${ esEs.SIGNIN.MESSAGES.FAIL_SERVER }`, ConfigSite.TIME_DISPLAY_MESSAGES);
      break;
    };
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="signin-container">
        <Spin size="large" spinning={this.state.displaySpinner}>
          <img width="250px" alt="login logo" src={require('../../assets/img/login-logo.png')}/>
          <Form onSubmit={this.handleSubmit} layout="vertical" className="login-form">
            <FormItem>
              {getFieldDecorator('username', {
                initialValue: this.state.username,
                rules: [
                  {required: true, message: `${ esEs.SIGNIN.INPUTS.VALIDATION_USERNAME }` }],
              })(
                <Input prefix={<Icon type="user"/>} style={{ color: 'rgba(0,0,0,.25)' }} name="username" 
                onChange={this.handleInputChange} disabled={this.props.loading} placeholder={esEs.SIGNIN.INPUTS.USERNAME}/>
              )}
            </FormItem>
            <Form.Item>
              {getFieldDecorator('password', {
                initialValue: this.state.password,
                rules: [{ required: true, message: `${ esEs.SIGNIN.INPUTS.VALIDATION_PASSWORD }` }],
              })(
                <Input.Password
                  prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  onChange={this.handleInputChange} disabled={this.props.loading} placeholder={esEs.SIGNIN.INPUTS.PASSWORD} name="password"
                />,
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('isRememberChecked', {
                valuePropName: 'checked',
                initialValue: this.state.isRememberChecked,
              })(<Checkbox onChange={this.onChangeRememberMe}>{esEs.SIGNIN.BUTTONS.REMEMBER_ME}</Checkbox>)}
              <Link to="/forgot">
                <Button type="link">
                  {esEs.SIGNIN.BUTTONS.FORGOT_PASSWORD}
                </Button>
              </Link>
              <Button type="primary" loading={this.props.loading} htmlType="submit" className="login-form-button">
                {esEs.SIGNIN.BUTTONS.LOGIN}
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    );
  };
}

const SigninForm = Form.create({ name: 'form_signin' })(Signin);

export default SigninForm;



// WEBPACK FOOTER //
// ./src/components/signin/signin.js